"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderType = exports.OrderCardWithButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _ButtonGroup = require("../ButtonGroup");
var _Order = require("../Order");
var _FoodOrder = require("../FoodOrder");
var _OrderWithMoreBtn = require("../OrderWithMoreBtn");
var _useTracking = require("../../hooks/useTracking");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var OrderType;
exports.OrderType = OrderType;
(function (OrderType) {
  OrderType["shopee"] = "shopee";
  OrderType["food"] = "food";
  OrderType["prediction"] = "prediction";
  OrderType["orderWithHotQuestion"] = "orderWithHotQuestion";
})(OrderType || (exports.OrderType = OrderType = {}));
var PREFIX = (0, _getPrefixCls.getPrefixCls)('order-card-with-button');
var OrderCardWithButton = function OrderCardWithButton(props) {
  var order = props.order,
    buttons = props.buttons,
    _props$orderType = props.orderType,
    orderType = _props$orderType === void 0 ? OrderType.shopee : _props$orderType,
    componentTrackingData = props.componentTrackingData,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    isUIOptimisation = props.isUIOptimisation;
  var _useComponentTracking = (0, _useTracking.useComponentTracking)({
      componentTrackingData: componentTrackingData,
      componentData: _objectSpread({}, props)
    }),
    orderCardTracking = _useComponentTracking.result.orderCard;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx.default)(PREFIX, className)
  }, orderCardTracking === null || orderCardTracking === void 0 ? void 0 : orderCardTracking.trackingImpressionProps), (orderType === OrderType.shopee || orderType === OrderType.orderWithHotQuestion) && /*#__PURE__*/_react.default.createElement(_Order.Order, order), orderType === OrderType.food && isUIOptimisation ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: '12px',
      borderRadius: '6px'
    }
  }, /*#__PURE__*/_react.default.createElement(_FoodOrder.FoodOrder, (0, _extends2.default)({}, order, {
    isUIOptimisation: isUIOptimisation,
    wrapperStyle: {
      padding: '8px',
      backgroundColor: '#f8f8f8'
    }
  }))) : /*#__PURE__*/_react.default.createElement(_FoodOrder.FoodOrder, (0, _extends2.default)({}, order, {
    isUIOptimisation: isUIOptimisation
  })), orderType === OrderType.prediction && /*#__PURE__*/_react.default.createElement(_OrderWithMoreBtn.OrderWithMoreBtn, props), /*#__PURE__*/_react.default.createElement(_ButtonGroup.ButtonGroup, buttons));
};
exports.OrderCardWithButton = OrderCardWithButton;